<mat-dialog-content [formGroup]="formGroup">
<h2 mat-dialog-title>Move Review</h2>
  <p>To move this review to another entity, choose the entity type, and enter the airport id or business id to move it to.</p>
  <br />
  <p>
    <mat-form-field>
      <mat-select placeholder="New Entity Type *" [(value)]="selectedEntityType" name="type" formControlName="type">
        <mat-option value="Airport">Airport</mat-option>
        <mat-option value="Business">Business</mat-option>
      </mat-select>
    </mat-form-field>
  </p>
  <p>
    <mat-form-field class="address_row_item">
      <input matInput
             placeholder="New Airport Identifier or Numeric Business ID *"
             formControlName="entity_id"
             [(ngModel)]="selectedEntity">
    </mat-form-field>
  </p>
</mat-dialog-content>
<div mat-dialog-actions>
  <button mat-button class="aopa-mat-btn aopa-mat-btn--outlined" (click)="cancel()" cdkFocusInitial>Cancel</button>
  <button mat-button class="aopa-mat-btn aopa-mat-btn--outlined" (click)="submitForm()" >Move</button>
</div>
